import { Trash2, Recycle, Leaf, Droplets, Home, Building2, GraduationCap, Landmark } from "lucide-react";
import { Button } from "@/components/ui/button";
const Services = () => {
  const binServices = [{
    icon: Trash2,
    title: "Bac noir (ordures)",
    color: "bg-foreground"
  }, {
    icon: Recycle,
    title: "Bac bleu (recyclage)",
    color: "bg-primary"
  }, {
    icon: Leaf,
    title: "Bac brun (compost)",
    color: "bg-secondary"
  }];
  const pressureServices = [{
    icon: Home,
    title: "Revêtement maison",
    description: "Nettoyage complet de l'extérieur de votre maison"
  }, {
    icon: Droplets,
    title: "Entrée de maison / béton",
    description: "Restaurez l'apparence de vos surfaces bétonnées"
  }, {
    icon: Building2,
    title: "Surfaces extérieures",
    description: "Terrasses, patios, clôtures et plus encore"
  }];
  const clientTypes = [{
    icon: Home,
    label: "Résidentiel"
  }, {
    icon: Building2,
    label: "Commercial"
  }, {
    icon: Landmark,
    label: "Industriel"
  }, {
    icon: GraduationCap,
    label: "Écoles"
  }, {
    icon: Landmark,
    label: "Municipalités"
  }];
  return <section id="services" aria-labelledby="services-heading" className="section-padding bg-muted">
      <div className="container-narrow mx-auto">
        {/* Section Header */}
        <header className="text-center mb-16">
          <span className="text-accent font-semibold text-sm uppercase tracking-wider">Nos services</span>
          <h2 id="services-heading" className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mt-3 mb-4">
            Services de nettoyage de bacs et haute pression
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Du nettoyage de bacs à ordures au lavage haute pression résidentiel à Valleyfield, Beauharnois, Soulanges et Haut-Saint-Laurent.
          </p>
        </header>

        {/* Bin Cleaning Services */}
        <div className="mb-16">
          <div className="bg-card rounded-2xl shadow-card p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <Trash2 className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-heading text-2xl font-bold text-[#080808]">NETTOYAGE DE BACS    </h3>
                <p className="text-accent font-semibold">Avril à Octobre</p>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-8">
              {binServices.map((service, index) => <div key={index} className="flex items-center gap-4 p-4 rounded-xl border border-border hover:border-primary/30 hover:shadow-sm transition-all duration-300">
                  <div className={`w-10 h-10 rounded-lg ${service.color} flex items-center justify-center`}>
                    <service.icon className="w-5 h-5 text-background" />
                  </div>
                  <span className="font-semibold text-foreground">{service.title}</span>
                </div>)}
            </div>

            <div className="text-center">
              <Button variant="cta" size="lg" asChild>
                <a href="#soumission">Réserver mon nettoyage</a>
              </Button>
            </div>
          </div>
        </div>

        {/* Pressure Washing Services */}
        <div className="mb-16">
          <div className="bg-card rounded-2xl shadow-card p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center">
                <Droplets className="w-6 h-6 text-secondary" />
              </div>
              <div>
                <h3 className="font-heading text-2xl font-bold text-black">NETTOYAGE HAUTE PRESSION </h3>
                <p className="text-accent font-semibold">Soumission gratuite</p>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-8">
              {pressureServices.map((service, index) => <div key={index} className="p-6 rounded-xl border border-border hover:border-secondary/30 hover:shadow-sm transition-all duration-300 hover-lift">
                  <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-4">
                    <service.icon className="w-6 h-6 text-secondary" />
                  </div>
                  <h4 className="font-heading font-bold text-lg text-foreground mb-2">{service.title}</h4>
                  <p className="text-muted-foreground text-sm">{service.description}</p>
                </div>)}
            </div>

            <div className="text-center">
              <Button variant="forest" size="lg" asChild>
                <a href="#soumission">Demander une soumission gratuite</a>
              </Button>
            </div>
          </div>
        </div>

        {/* Client Types */}
        <div className="text-center">
          <h3 className="font-heading text-xl font-bold text-foreground mb-6">Types de clients desservis</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {clientTypes.map((client, index) => <div key={index} className="flex items-center gap-2 bg-card rounded-full px-5 py-3 shadow-sm border border-border">
                <client.icon className="w-5 h-5 text-primary" />
                <span className="font-medium text-foreground">{client.label}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default Services;